import { render, staticRenderFns } from "./PeVerdict.vue?vue&type=template&id=1c97bb68&"
import script from "./PeVerdict.vue?vue&type=script&lang=js&"
export * from "./PeVerdict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports